import React, { Component } from "react";
import {
  message,
  Row,
  Col,
  DatePicker,
  Tag,
  Alert,
  Typography,
} from "antd";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import {
  ModalItem,
  Form,
  FormItem,
  ErrorItem,
  ButtonItem,
} from "./Items";

const { Text } = Typography;

class ModalEditarFechas extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    diasCredito: 0,
    fechaActualDisplayVen: null,
    fechaSugeridaDisplayVen: null,
    fechaActualDisplayPago: null,
    fechaSugeridaDisplayPago: null,
    esCuentasPorPagar : false, 
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.cargarDatos();
    }
  }

  cargarDatos() {
    const record = this.props.venta || this.props.factura;
    
    if (!record) return;
    const esCuentasPorPagar = !!record.proveedor;

    let diasCredito = 0;
    if (esCuentasPorPagar) {
      diasCredito = record?.proveedor?.diasCredito || 0; 
    } else {
      diasCredito = record?.cliente?.diasCredito || 0;
    }

    const fechaBaseVen = record.fechaVencimiento
      ? moment(record.fechaVencimiento)
      : moment(record.fechaVenta);

    const fechaSugeridaVen = moment(fechaBaseVen).add(diasCredito, "days");

    const fechaBasePago = record.fechaPago
      ? moment(record.fechaPago)
      : moment(record.fechaVenta);

    const fechaSugeridaPago = moment(fechaBasePago).add(diasCredito, "days");
    this.setState({
      fechaActualDisplayVen: fechaBaseVen,
      fechaSugeridaDisplayVen: fechaSugeridaVen,
      fechaActualDisplayPago: fechaBasePago,
      fechaSugeridaDisplayPago: fechaSugeridaPago,
      diasCredito: diasCredito,
      esCuentasPorPagar: esCuentasPorPagar,
    });
    setTimeout(() => {
      if (this.formRef.current) {
        this.formRef.current.setFieldsValue({
          fechaVencimiento: fechaBaseVen,
          fechaPago: fechaBasePago,
        });
      }
    }, 100);
  }

  cerrarModal(exitoso = false) {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({
      loading: false,
      fechaActualDisplayVen: null,
      fechaSugeridaDisplayVen: null,
      fechaActualDisplayPago: null,
      fechaSugeridaDisplayPago: null,
      esCuentasPorPagar: false,
    });

    if (exitoso) {
      this.props.onSuccess();
    } else {
      this.props.onCancel();
    }
  }

  onFinish(values) {
    const record = this.props.venta || this.props.factura;
    const { esCuentasPorPagar } = this.state;

    this.setState({ loading: true });
    let url = "";
    let payload = {};

    if (esCuentasPorPagar) {
      url = "cuentasporpagar/editarFechas"; 
      payload = {
        facturaId: record._id, 
        empresaId: this.props.empresaId,
        fechaVencimiento: values.fechaVencimiento,
        fechaPago: values.fechaPago,
      };
    } else {
      url = "cuentasporcobrar/editarFechas";
      payload = {
        ventaId: record._id,
        empresaId: this.props.empresaId, 
        fechaVencimiento: values.fechaVencimiento,
        fechaPago: values.fechaPago,
      };
    }

    axios
      .post(url, payload, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Fechas Actualizadas Correctamente");
          this.cerrarModal(true);
        } else {
          message.error("Error al actualizar datos");
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.error("Error:", err);
        message.error("Error de conexión");
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }



  render() {
    const {
      fechaActualDisplayPago,
      fechaSugeridaDisplayPago,
      fechaActualDisplayVen,
      fechaSugeridaDisplayVen,
      diasCredito,
      esCuentasPorPagar,
    } = this.state;
    
    const record = this.props.venta || this.props.factura;
    
    const fechaOrigen = esCuentasPorPagar 
        ? (record?.fechaFactura || record?.createdAt) 
        : (record?.fechaVenta || record?.createdAt);
        
    const fechaOrigenFormateada = fechaOrigen ? moment(fechaOrigen).format("DD/MM/YYYY") : "S/F";
    
    const entidadNombre = esCuentasPorPagar 
        ? (record?.proveedorNombre || record?.proveedor?.razonSocial || "Proveedor")
        : (record?.clienteNombre || record?.cliente?.nombre || "Cliente");

    const etiquetaFecha = esCuentasPorPagar ? "Fecha de Factura" : "Fecha de Venta";
    const numeroDocumento = esCuentasPorPagar 
        ? (record?.numeroFactura || "") 
        : (record?.numero || "");

    return (
      <ModalItem
        title={`Editar Fechas - ${numeroDocumento || ""}`}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrarModal()}
        width={500}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="form-editar-fechas"
          layout="vertical"
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
          bottom={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 20,
              }}
            >
              <ButtonItem
                type="primary"
                onClick={() => this.cerrarModal()}
                rojo
                style={{ marginRight: 8 }}
              >
                Cancelar
              </ButtonItem>
              <ButtonItem type="primary" htmlType="submit">
                Guardar
              </ButtonItem>
            </div>
          }
        >
          <Row gutter={[16, 16]}>
            <Alert
                message={
                  <span>
                    Cálculo basado en la <b>{etiquetaFecha} ({fechaOrigenFormateada})</b> y los <b>{diasCredito} días de crédito</b> de {entidadNombre}.
                  </span>
                }
                type="info"
                showIcon
                style={{ marginBottom: 15, fontSize: "12px", width: "100%" }}
              />
            <Col span={24}>
            {fechaActualDisplayVen && (
                <div
                  style={{
                    marginBottom: 10,
                    padding: "10px",
                    background: "#fafafa",
                    borderRadius: "6px",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <div style={{ marginBottom: 5 }}>
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      Vencimiento Actual:
                    </Text>{" "}
                    <Tag color="green">
                      {fechaActualDisplayVen?.format("DD/MM/YYYY")}
                    </Tag>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      Sugerida (+{diasCredito} días):
                    </Text>
                    <Tag color="blue">
                      {fechaSugeridaDisplayVen?.format("DD/MM/YYYY")}
                    </Tag>
                  </div>
                </div>
              )}

            
              <FormItem
                name="fechaVencimiento"
                label="Fecha de Vencimiento"
              >
                <DatePicker
                  style={{ width: "90%" }}
                  format="DD/MM/YYYY"
                  placeholder="Seleccione fecha"
                />
              </FormItem>

                {fechaActualDisplayPago && (
                <div
                  style={{
                    marginBottom: 10,
                    padding: "10px",
                    background: "#fafafa",
                    borderRadius: "6px",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <div style={{ marginBottom: 5 }}>
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      Fecha probable de Pago Actual:
                    </Text>{" "}
                    <Tag color="green">
                      {fechaActualDisplayPago?.format("DD/MM/YYYY")}
                    </Tag>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      Sugerida (+{diasCredito} días):
                    </Text>
                    <Tag color="blue">
                      {fechaSugeridaDisplayPago?.format("DD/MM/YYYY")}
                    </Tag>
                  </div>
                </div>
              )}

              <FormItem
                name="fechaPago"
                label="Fecha Probable de Pago"
              >
                <DatePicker
                  style={{ width: "90%" }}
                  format="DD/MM/YYYY"
                  placeholder="Seleccione fecha"
                />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalEditarFechas);
